import { baseApi } from "../api";
import { ContactMessagePayload } from "./types";

export const contactApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * `POST /contact` answers `{ result: "<success message>" }`, so the
     * baseQuery's envelope unwrap leaves the bare message string.
     */
    sendContactMessage: builder.mutation<string, ContactMessagePayload>({
      query: (payload) => ({
        url: "/contact",
        method: "post",
        data: payload,
      }),
    }),
  }),
});

export const { useSendContactMessageMutation } = contactApi;
